import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetDraftInvoiceResponse } from '@/api/handlers/resources/purchases/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { PurchaseQueryKeys } from './purchaseQueryKeys';

/**
 * Full nested draft for resume/edit (`GET /purchases/draft-invoices/{id}`).
 * Disabled until a real id is present, so the request never fires on the
 * fresh-draft route. Short staleTime — the user may have just saved newer
 * fields from another tab.
 */
export const useDraftInvoiceQuery = (
    draftId: string | null,
    enabled = true,
) => {
    const { apiClient } = useApi();
    const id = draftId?.trim() ? draftId : null;

    return useQuery<ApiResponse<GetDraftInvoiceResponse>>({
        queryKey: PurchaseQueryKeys.draftInvoice(id ?? ''),
        queryFn: () => apiClient.purchases.getDraftInvoice(id ?? ''),
        enabled: enabled && id !== null,
        staleTime: 30_000,
    });
};
